import HomeLayout from "routes/layouts/HomeLayout";

function NotFound() {
  return (
    <HomeLayout>
      <div className="flex flex-col items-center justify-center h-screen text-center">
        <h1 className="text-2xl font-bold text-blue-600">Not Found</h1>
        <p className="text-lg text-gray-600">
          The page you are looking for does not exist.
        </p>
      </div>
    </HomeLayout>
  );
}

export default NotFound;
